// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"4eab59a9","291":"6f5829db","416":"30fe8979","465":"7654ab32","740":"e7c7c000"}[chunkId] + ".css";
};